import React from 'react';
import { Lightbulb, AlertTriangle, Info } from 'lucide-react';

const STYLES = {
  tip: { box: 'border-emerald-200 bg-emerald-50 text-emerald-900', icon: Lightbulb, iconColor: 'text-emerald-600', label: 'Tipp' },
  warning: { box: 'border-amber-200 bg-amber-50 text-amber-900', icon: AlertTriangle, iconColor: 'text-amber-600', label: 'Achtung' },
  info: { box: 'border-sky-200 bg-sky-50 text-sky-900', icon: Info, iconColor: 'text-sky-600', label: 'Hinweis' },
};

export function Callout({ variant = 'tip', title, children, testId }) {
  const s = STYLES[variant] || STYLES.tip;
  const Icon = s.icon;
  return (
    <div role="note" data-testid={testId || `callout-${variant}`} className={`flex gap-3 rounded-xl border p-4 sm:p-5 ${s.box}`}>
      <Icon className={`mt-0.5 h-5 w-5 flex-none ${s.iconColor}`} aria-hidden="true" />
      <div className="text-sm leading-relaxed">
        <p className="font-semibold">{title || s.label}</p>
        <div className="mt-1">{children}</div>
      </div>
    </div>
  );
}

export default Callout;
